export const styles = theme => ({
  shapeCircle: {
    zIndex: 5,
    width: 15,
    height: 15,
    borderRadius: '50%',
    border: '1px solid #fff',
  },
  shapeTriangle: {
    display: 'inline-block',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '0 100px 100px 100px',
  },
  shapeSquare: {
    width: 15,
    height: 15,
    border: '1px solid #fff',
  },
  iconSvg: {
    color: 'white',
    fontSize: '1.2em',
  },
  triangleRed: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '0 9px 15px 10px',
    borderColor: 'transparent transparent #fff transparent',
    position: 'relative',
    '&::before': {
      content: '""',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '0 8px 12px 7px',
      borderColor: 'transparent transparent #ff0000 transparent',
      position: 'absolute',
      top: 2,
      left: -7,
    },
  },
  triangleYellow: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '0 9px 15px 10px',
    borderColor: 'transparent transparent #fff transparent',
    position: 'relative',
    '&::before': {
      content: '""',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '0 8px 12px 7px',
      borderColor: 'transparent transparent #F89408 transparent',
      position: 'absolute',
      top: 2,
      left: -7,
    },
  },
  iconSvgTriangle: {
    color: 'white',
    position: 'absolute',
    bottom: -17,
    left: -3,
    top: 6,
    fontSize: 8,
  },
  iconSvgEws: {
    fontSize: '1.4em',
  },
  shapeEws:{
    color: 'transparent',
    backgroundColor: 'transparent',
  }
});
